module.exports = __webpack_public_path__ + "components/Modals/SideDescription/img/zabytek.jpg?51f14897";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img/zabytek.jpg
// module id = 2436
// module chunks = 0